var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Popper } from "@material-ui/core";
import { Button } from "../buttons";
import * as uuid from 'uuid';
import { EditModeContext } from "../../context";
import $ from 'jquery';
var DispatchEdit = /** @class */ (function (_super) {
    __extends(DispatchEdit, _super);
    function DispatchEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            didChange: false,
            showCustomEdit: false
        };
        _this.key = uuid.v4();
        _this.childRef = React.createRef();
        _this.detectChange = _this.detectChange.bind(_this);
        return _this;
    }
    DispatchEdit.prototype.detectChange = function (e) {
        if (this.state.defaultInner != e.currentTarget.innerText) {
            this.setState({ didChange: true, updatedContent: e.currentTarget.innerText });
        }
        else {
            this.setState({ didChange: false, updatedContent: undefined });
        }
    };
    DispatchEdit.prototype.getContainerProps = function (active) {
        var _this = this;
        if (!active) {
            return {};
        }
        var props = {
            contentEditable: this.context && !this.props.editRenderer,
            onBlur: this.detectChange,
            onInput: this.detectChange,
            suppressContentEditableWarning: true,
            key: this.key
        };
        if (this.props.catchOnClick || this.props.editRenderer) {
            props.onClick = function (e) {
                e.preventDefault();
                e.stopPropagation();
                if (_this.props.editRenderer) {
                    _this.setState({ showCustomEdit: true });
                }
            };
        }
        if (this.props.onlyNumbers) {
            props.onKeyPress = function (e) {
                if (isNaN(parseInt(String.fromCharCode(e.which)))) {
                    e.preventDefault();
                }
            };
        }
        return props;
    };
    DispatchEdit.prototype.getChildProps = function (active) {
        return __assign(__assign({}, this.getCustomEditProps()), { containerProps: this.getContainerProps(active), ref: this.childRef });
    };
    DispatchEdit.prototype.getCustomEditProps = function () {
        var _this = this;
        return {
            ref: this.childRef,
            dismiss: function () {
                _this.setState({ showCustomEdit: false });
            },
            commit: function (val) {
                if (_this.childRef.current) {
                    _this.childRef.current.innerText = val;
                    _this.detectChange({ currentTarget: _this.childRef.current });
                    _this.setState({ showCustomEdit: false, showSaveAll: _this.props.commitForIdentifiers && _this.props.commitForIdentifiers.length > 1 });
                }
                if (_this.props.commitForIdentifiers && _this.props.commitForIdentifiers.length > 1) {
                    _this.props.commitForIdentifiers.forEach(function (identifier) {
                        if (_this.props.identifier != identifier) {
                            var editor = DispatchEdit.dispatchEditors[identifier];
                            if (editor && editor.childRef.current) {
                                editor.childRef.current.innerText = val;
                                editor.detectChange({ currentTarget: editor.childRef.current });
                                editor.setState({ showCustomEdit: false });
                            }
                        }
                    });
                }
            }
        };
    };
    DispatchEdit.prototype.componentDidMount = function () {
        if (this.childRef.current && !this.state.defaultInner) {
            this.setState({ defaultInner: this.childRef.current.innerText });
        }
        DispatchEdit.dispatchEditors[this.props.identifier] = this;
    };
    DispatchEdit.prototype.componentWillUnmount = function () {
        delete DispatchEdit.dispatchEditors[this.props.identifier];
    };
    DispatchEdit.prototype.render = function () {
        var _this = this;
        if (!this.context || this.props.disable) {
            return this.props.children(this.getChildProps(false));
        }
        var comps = [];
        if (this.state.didChange) {
            var childs = this.props.children(this.getChildProps(true));
            if (this.childRef.current) {
                var actions = React.createElement(Popper, { anchorEl: this.childRef.current, open: true, placement: 'right', modifiers: {
                        flip: {
                            enabled: true,
                        },
                        preventOverflow: {
                            enabled: true,
                            boundariesElement: 'window',
                        }
                    }, style: { zIndex: 300 } },
                    React.createElement("div", { style: { display: 'flex' } },
                        React.createElement(Button, { buttonText: 'Save', className: 'dispatch-edit-save' + this.props.identifier.split(':').slice(0, -1).join(''), loading: this.state.loading, onClick: function () {
                                _this.setState({ loading: true });
                                _this.props.commitChanges(_this.state.updatedContent).finally(function () {
                                    _this.key = uuid.v4();
                                    _this.setState({ didChange: false, defaultInner: undefined, updatedContent: undefined, loading: false });
                                });
                            } }),
                        this.state.showSaveAll &&
                            React.createElement(Button, { buttonText: 'Save All', loading: this.state.loading, style: { marginRight: 8 }, backgroundColor: 'var(--primary)', textColor: 'white', onClick: function () {
                                    $('.dispatch-edit-save' + _this.props.identifier.split(':').slice(0, -1).join('')).each(function () {
                                        $(this).trigger('click');
                                    });
                                } })));
                comps.push(actions);
            }
            comps.push(childs);
        }
        else {
            if (this.state.showCustomEdit && this.props.editRenderer) {
                comps.push(this.props.editRenderer(this.getCustomEditProps()));
            }
            comps.push(this.props.children(this.getChildProps(true)));
        }
        return comps;
    };
    DispatchEdit.contextType = EditModeContext;
    DispatchEdit.dispatchEditors = {};
    return DispatchEdit;
}(React.Component));
export default DispatchEdit;
//# sourceMappingURL=dispatchedit.js.map